'use client'

import { createInstance, type Resource } from 'i18next'
import { I18nextProvider } from 'react-i18next'

import initTranslations from '@/app/i18n'
import { $Tuple } from '@/types'
import Resources from '~/@types/resources'

type Props = {
  children: React.ReactNode
  locale: string
  namespaces: keyof Resources | $Tuple<keyof Resources>
  resources?: Record<string, Resource>
}

export default function TranslationsProvider({ children, locale, namespaces, resources }: Props) {
  const i18n = createInstance()

  initTranslations(locale, namespaces, i18n, resources)

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
